import { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Location } from "history";

import { getBackend } from "../lib/backend/Backend2";
import { getLoginRedirectURL, setDocsJwtCookie } from "../lib/Auth";
import Loader from "./Loader";

type Props = {
    location: Location;
};

const LoginRefresh = (props: Props) => {
    const [is_loading, setIsLoading] = useState(true);

    const { location } = props;
    const search_params = new URLSearchParams(location.search);
    const redirect = search_params.get("redirect") || getLoginRedirectURL();
    const reload = search_params.get("reload") !== null;

    useEffect(() => {
        const refreshDocsToken = async () => {
            const { token } = await getBackend().users.refreshDocsToken({});
            setDocsJwtCookie(token);
            setIsLoading(false);

            if (reload) {
                window.location.href = redirect;
            }
        };
        refreshDocsToken();
    }, []);

    if (is_loading) {
        return (
            <section id="register">
                <div className="caption_div">
                    <Loader />
                </div>
            </section>
        );
    }

    return <Redirect to={redirect} />;
};

export default LoginRefresh;
